module.exports = __webpack_public_path__ + "img/welcomes-preview-vip-2.124f2274.png";